import PropTypes from 'prop-types';

export const status = PropTypes.oneOf([
  'PENDING_CONFIRMATION',
  'PENDING_MODERATION',
  'PENDING_ASSIGNMENT',
  'PENDING_PAYMENT',
  'ASSIGNED',
  'IN_TRANSIT',
]).isRequired;

export const change = PropTypes.oneOf(['NONE', 'EDIT', 'CANCEL', 'CREATE']).isRequired;

export const action = PropTypes.oneOf(['EDIT', 'CANCEL']).isRequired;

export const shipperOrders = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    start_time_from: PropTypes.string.isRequired,
    start_time_to: PropTypes.string.isRequired,
    start_time_from_tz: PropTypes.string.isRequired,
    start_time_to_tz: PropTypes.string.isRequired,
    status,
    change,
  })
);
